import React, { Component } from "react";
import AthleteAdminList from "./AthleteAdminList";
import "./AthleteSearch.css";
import {
  Dropdown,
  Input,
  Icon,
  Button,
  Modal,
  TransitionablePortal,
  Form,
  Confirm,
} from "semantic-ui-react";
import { connect } from "react-redux";
import { TbLetterA } from "react-icons/tb";
import { MdMobileFriendly } from "react-icons/md";
import { Link, Redirect } from "react-router-dom";
import * as yup from "yup";
import {
  addAthlete,
  resetAthlete,
  addSchool,
  editSchool,
} from "../../store/actions/athleteActions";
import SchoolList from "./SchoolList";
import "doka/doka.css";
import {
  createDefaultImageReader,
  createDefaultImageWriter,
  locale_en_gb,
  plugin_crop_locale_en_gb,
  plugin_finetune_locale_en_gb,
  plugin_annotate_locale_en_gb,
  blobToFile,
} from "doka";
import heic2any from "heic2any";
import { DokaImageEditor } from "react-doka";
import { firestoreConnect } from "react-redux-firebase";
import { compose } from "redux";
import SportList from "./SportList";
import AddNewSport, { AddNewSportIcon } from "../layout/AddNewSport";
import PositionList from "./PositionList";
import AddNewPosition, { AddNewPositionIcon } from "../layout/AddNewPosition";
import SportDetails from "./SportDetails";
import NewPlayersToWatch from "../layout/NewPlayersToWatch";
import SkillsList from "./SkillsList";
import ClassYearDropDown from "../layout/ClassYearDropDown";
import { heicRegex } from "../../utils/regex";

const debounce = (callback, delay) => {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => callback(...args), delay);
  };
};

const filteredAcademicsOptions = [
  { key: 1, text: "ACT", value: 1 },
  { key: 2, text: "SAT", value: 2 },
];

const classOptions = [
  { key: 1, text: "2014", value: 2014 },
  { key: 2, text: "2015", value: 2015 },
  { key: 3, text: "2016", value: 2016 },
  { key: 4, text: "2017", value: 2017 },
  { key: 5, text: "2018", value: 2018 },
  { key: 6, text: "2019", value: 2019 },
  { key: 7, text: "2020", value: 2020 },
  { key: 8, text: "2021", value: 2021 },
  { key: 9, text: "2022", value: 2022 },
  { key: 10, text: "2023", value: 2023 },
  { key: 11, text: "2024", value: 2024 },
  { key: 12, text: "2025", value: 2025 },
  { key: 13, text: "2026", value: 2026 },
  { key: 14, text: "2027", value: 2027 },
  { key: 15, text: "2028", value: 2028 },
  { key: 16, text: "2029", value: 2029 },
  { key: 17, text: "2030", value: 2030 },
  { key: 18, text: "College Transfer", value: "college_transfer" },
];

export const committedOptions = [
  { key: 1, text: "Committed", value: "Committed" },
  { key: 2, text: "Uncommitted", value: "Uncommitted" },
];

var initialFirstName = "";
var initialLastName = "";
var initialEmail = "";
var initialAdvocate = "";
var initialClass = "";
var initialSport = "";
var initialPosition = "";
var initialTeamName = "";

var initialCommitted = false;
var initialSchoolName = "";

var initialEditSchoolName = "";

const schema = yup.object().shape({
  email: yup.string().email(),
});

const initialState = {
  debounceSearch: "",
  showNewSportField: false,
  showNewPositionField: false,
  filteredGradClass: 0,
  filteredSport: null,
  filteredPosition: "None",
  filteredAcademics: "None",
  search: "",
  key: Date.now(),
  searchEnabled: true,
  firstName: "",
  firstNameChanged: false,
  lastName: "",
  lastNameChanged: false,
  email: "",
  emailChanged: false,
  advocate: "",
  advocateChanged: false,
  class: "",
  classChanged: false,
  sport: "",
  sportChanged: false,
  position: "",
  positionChanged: false,
  teamName: "",
  teamNameChanged: false,

  addAthleteOpen: false,
  changesMade: false,
  athleteTriedToUpdate: false,
  isLoading: false,
  emailError: false,
  formError: false,
  confirmOpen: false,

  committed: false,
  committedValue: "Uncommitted",
  committedChanged: false,

  committedOpen: false,
  addNewSchoolOpen: false,
  editSportOpen: false,
  innerPostionOpen: false,
  playersOpen: false,
  managePlaylists: false,

  newThumbnailImage: null,
  newThumbnailImageUrl: null,
  cropImageOpen: false,
  imageCropped: false,

  schoolName: "",
  schoolNameChanged: false,

  editSchoolOpen: false,
  editSchoolId: null,
  editSchoolName: "",
  editSchoolNameChanged: false,
  editSchoolLogo: null,
  editSchoolLogoChanged: false,

  editCropImageOpen: false,
  editImageCropped: false,
  newEditThumbnailImage: null,
  newEditThumbnailImageUrl: null,
};

var searchIcon = null;
var searchBar = null;

const editorConfig = {
  imageReader: createDefaultImageReader({
    preprocessImageFile: async (file, options, onprogress) => {
      // If is not of type HEIC we skip the file
      if (!heicRegex.test(file.type)) return file;

      // Let's turn the HEIC image into JPEG so the browser can read it
      const blob = await heic2any({
        blob: file,
        toType: "image/jpeg",
        quality: 0.94,
      });

      // The editor expects a File so let's convert our Blob
      return blobToFile(blob, file.name);
    },
  }),
  imageWriter: createDefaultImageWriter({
    targetSize: {
      width: 150,
      height: 150,
      upscale: true,
    },
  }),
  imageCropAspectRatio: 1,
  locale: {
    ...locale_en_gb,
    ...plugin_crop_locale_en_gb,
    ...plugin_finetune_locale_en_gb,
    ...plugin_annotate_locale_en_gb,
  },
};

class AthleteAdminSearch extends Component {
  constructor(props) {
    super(props);

    this.state = initialState;

    searchIcon = "search";
  }

  handleClick = () => {
    this.setState(
      {
        debounceSearch: "",
        search: "",
      },
      () => {
        this.updateKey();
        searchIcon = "search";
      }
    );
  };

  handleAddAthleteClick = () => {
    this.setState({
      addAthleteOpen: true,
    });
  };

  handleCommittedClick = () => {
    this.setState({
      committedOpen: true,
    });
  };
  handleEditSportsClick = () => {
    this.setState({
      editSportOpen: true,
    });
  };
  handleEditPositionClick = () => {
    this.setState({
      innerPostionOpen: true,
    });
  };
  handlePlayersClick = () => {
    this.setState({
      playersOpen: true,
    });
  };

  checkSearchEnabled = () => {
    if (
      this.state.filteredGradClass !== 0 ||
      this.state.filteredSport ||
      this.state.filteredPosition !== "None" ||
      this.state.filteredAcademics !== "None"
    ) {
      this.setState({
        searchEnabled: false,
      });
    } else {
      this.setState({
        searchEnabled: true,
      });
    }
  };
  debounceLog = debounce((query) => {
    this.setState({
      debounceSearch: query,
    });
  }, 500);
  handleOnChange = (e, data) => {
    switch (data.name) {
      case "filteredClass":
        this.updateKey();

        switch (data.value) {
          case 1:
            this.setState(
              {
                filteredGradClass: 2022,
              },
              () => {
                this.checkSearchEnabled();
              }
            );
            break;
          case 2:
            this.setState(
              {
                filteredGradClass: 2023,
              },
              () => {
                this.checkSearchEnabled();
              }
            );
            break;
          case 3:
            this.setState(
              {
                filteredGradClass: 2024,
              },
              () => {
                this.checkSearchEnabled();
              }
            );
            break;
          case 4:
            this.setState(
              {
                filteredGradClass: 2025,
              },
              () => {
                this.checkSearchEnabled();
              }
            );
            break;
          case 5:
            this.setState(
              {
                filteredGradClass: 2026,
              },
              () => {
                this.checkSearchEnabled();
              }
            );
            break;
          case data.value:
            this.setState(
              {
                filteredGradClass: data.value,
              },
              () => {
                this.checkSearchEnabled();
              }
            );
            break;
          default:
            this.setState(
              {
                filteredGradClass: 0,
              },
              () => {
                this.checkSearchEnabled();
              }
            );
        }
        break;
      case "filteredSport":
        this.updateKey();
        switch (data.value) {
          case data.value:
            if (data.value === "") {
              this.setState(
                {
                  filteredSport: null,
                  filteredPosition: "",
                },
                () => {
                  this.checkSearchEnabled();
                }
              );
            } else {
              this.setState(
                {
                  filteredSport: data.value,
                },
                () => {
                  this.checkSearchEnabled();
                }
              );
            }
            break;
          default:
            this.setState(
              {
                filteredSport: null,
              },
              () => {
                this.checkSearchEnabled();
              }
            );
        }
        break;
      case "filteredAcademics":
        this.updateKey();

        switch (data.value) {
          case 1:
            this.setState(
              {
                filteredAcademics: "ACT",
              },
              () => {
                this.checkSearchEnabled();
              }
            );
            break;
          case 2:
            this.setState(
              {
                filteredAcademics: "SAT",
              },
              () => {
                this.checkSearchEnabled();
              }
            );
            break;
          default:
            this.setState(
              {
                filteredAcademics: "None",
              },
              () => {
                this.checkSearchEnabled();
              }
            );
        }
        break;
      case "filteredSearch":
        this.debounceLog(e.target.value);
        this.setState(
          {
            search: e.target.value,
          },
          () => {
            if (this.state.search === "") {
              searchIcon = "search";
              this.updateKey();
            } else {
              searchIcon = (
                <Icon name="close" link onClick={this.handleClick} />
              );
            }
          }
        );
        break;
      default:
        this.updateKey();

        switch (data.value) {
          case data.value:
            if (data.value === "") {
              this.setState(
                {
                  filteredPosition: "",
                },
                () => {
                  this.checkSearchEnabled();
                }
              );
            } else {
              this.setState(
                {
                  filteredPosition: data.value,
                },
                () => {
                  this.checkSearchEnabled();
                }
              );
            }
            break;
          default:
            this.setState(
              {
                filteredPosition: "",
              },
              () => {
                this.checkSearchEnabled();
              }
            );
        }
    }
  };

  updateKey = () => {
    this.setState({ key: Date.now() });
  };

  confirmOpen = () => this.setState({ confirmOpen: true });

  EditpsOpen = () => this.setState({ editSportOpen: true });
  EditPostionOpen = () => this.setState({ innerPostionOpen: true });

  confirmCloseCancel = () =>
    this.setState({
      confirmOpen: false,
    });

  confirmClose = () => {
    this.setState(initialState, () => {
      this.handleClose();
    });
  };

  handleClose = () => {
    if (this.state.changesMade) {
      this.confirmOpen();
    } else {
      this.setState({
        addAthleteOpen: false,
      });
    }
  };

  handlespClose = () => {
    if (this.state.changesMade) {
      this.EditpsOpen();
    } else {
      this.setState({
        editSportOpen: false,
      });
    }
  };
  handlePostionClose = () => {
    if (this.state.changesMade) {
      this.EditPostionOpen();
    } else {
      this.setState({
        innerPostionOpen: false,
      });
    }
  };

  handleCommittedClose = () => {
    if (this.state.addNewSchoolOpen || this.state.editSchoolOpen) {
      return;
    } else {
      if (this.state.changesMade) {
        this.confirmOpen();
      } else {
        this.setState({
          committedOpen: false,
        });
      }
    }
  };

  handleNewSchoolClose = () => {
    if (this.state.cropImageOpen) {
      return;
    } else {
      if (this.state.changesMade) {
        this.confirmOpen();
      } else {
        this.setState({
          addNewSchoolOpen: false,
        });
      }
    }
  };

  handleEditSchoolClose = () => {
    if (this.state.editCropImageOpen) {
      return;
    } else {
      if (this.state.changesMade) {
        this.confirmOpen();
      } else {
        this.setState({
          editSchoolOpen: false,
        });
      }
    }
  };
  handlePlayertoWatchClose = () => {
    this.setState({
      playersOpen: false,
    });
  };
  handleManagePlaylistsClose = () => {
    this.setState({
      managePlaylists: false,
    });
  };

  onSelectSchool = (selectSchoolId, selectSchoolName, selectSchoolLogo) => {
    this.setState(
      {
        editSchoolOpen: true,
        editSchoolId: selectSchoolId,
        editSchoolName: selectSchoolName,
        editSchoolLogo: selectSchoolLogo,
      },
      () => {
        initialEditSchoolName = selectSchoolName;
      }
    );
  };

  handleChange = (e) => {
    this.setState(
      {
        [e.target.id]: e.target.value,
      },
      () => {
        const self = this;

        switch (e.target.id) {
          case "editSchoolName":
            if (e.target.value !== initialEditSchoolName) {
              this.setState(
                {
                  editSchoolNameChanged: true,
                },
                () => {
                  this.trackChanges();
                }
              );
            } else {
              this.setState(
                {
                  editSchoolNameChanged: false,
                },
                () => {
                  this.trackChanges();
                }
              );
            }
            break;

          case "schoolName":
            if (e.target.value !== initialSchoolName) {
              this.setState(
                {
                  schoolNameChanged: true,
                },
                () => {
                  this.trackChanges();
                }
              );
            } else {
              this.setState(
                {
                  schoolNameChanged: false,
                },
                () => {
                  this.trackChanges();
                }
              );
            }
            break;
          case "firstName":
            if (e.target.value !== initialFirstName) {
              this.setState(
                {
                  firstNameChanged: true,
                },
                () => {
                  this.trackChanges();
                }
              );
            } else {
              this.setState(
                {
                  firstNameChanged: false,
                },
                () => {
                  this.trackChanges();
                }
              );
            }
            break;
          case "lastName":
            if (e.target.value !== initialLastName) {
              this.setState(
                {
                  lastNameChanged: true,
                },
                () => {
                  this.trackChanges();
                }
              );
            } else {
              this.setState(
                {
                  lastNameChanged: false,
                },
                () => {
                  this.trackChanges();
                }
              );
            }
            break;
          case "teamName":
            if (e.target.value !== initialTeamName) {
              this.setState(
                {
                  teamNameChanged: true,
                },
                () => {
                  this.trackChanges();
                }
              );
            } else {
              this.setState(
                {
                  teamNameChanged: false,
                },
                () => {
                  this.trackChanges();
                }
              );
            }
            break;
          case "email":
            if (e.target.value !== initialEmail) {
              this.setState(
                {
                  emailChanged: true,
                },
                () => {
                  this.trackChanges();
                }
              );
            } else {
              this.setState(
                {
                  emailChanged: false,
                },
                () => {
                  this.trackChanges();
                }
              );
            }
            schema.isValid({ email: this.state.email }).then(function (valid) {
              if (valid) {
                self.setState(
                  {
                    emailError: false,
                  },
                  () => {
                    self.trackErrors();
                  }
                );
              } else {
                self.setState(
                  {
                    emailError: true,
                  },
                  () => {
                    self.trackErrors();
                  }
                );
              }
            });
            break;
          default:
            return;
        }
      }
    );
  };

  handleDropdownChange = (e, data) => {
    if (data.name === "classDropdown") {
      this.setState({
        class: data.value,
      });
      if (data.value !== initialClass) {
        this.setState(
          {
            classChanged: true,
          },
          () => {
            this.trackChanges();
          }
        );
      } else {
        this.setState(
          {
            classChanged: false,
          },
          () => {
            this.trackChanges();
          }
        );
      }
    }
    if (data.name === "sportDropdown") {
      this.setState({
        sport: data.value,
      });
      if (data.value !== initialSport) {
        this.setState(
          {
            sportChanged: true,
          },
          () => {
            this.trackChanges();
          }
        );
      } else {
        this.setState(
          {
            sportChanged: false,
          },
          () => {
            this.trackChanges();
          }
        );
      }
    }
    if (data.name === "positionDropdown") {
      this.setState({
        position: data.value,
      });
      if (data.value !== initialPosition) {
        this.setState(
          {
            positionChanged: true,
          },
          () => {
            this.trackChanges();
          }
        );
      } else {
        this.setState(
          {
            positionChanged: false,
          },
          () => {
            this.trackChanges();
          }
        );
      }
    }
    if (data.name === "advocateDropdown") {
      this.setState({
        advocate: data.value,
      });
      if (data.value !== initialAdvocate) {
        this.setState(
          {
            advocateChanged: true,
          },
          () => {
            this.trackChanges();
          }
        );
      } else {
        this.setState(
          {
            advocateChanged: false,
          },
          () => {
            this.trackChanges();
          }
        );
      }
    }

    if (data.name === "committedDropdown") {
      if (data.value === "Committed") {
        this.setState(
          {
            committed: true,
            committedValue: "Committed",
          },
          () => {
            if (this.state.committed !== initialCommitted) {
              this.setState(
                {
                  committedChanged: true,
                },
                () => {
                  this.trackChanges();
                }
              );
            } else {
              this.setState(
                {
                  committedChanged: false,
                },
                () => {
                  this.trackChanges();
                }
              );
            }
          }
        );
      } else {
        this.setState(
          {
            committed: false,
            committedValue: "Uncommitted",
          },
          () => {
            if (this.state.committed !== initialCommitted) {
              this.setState(
                {
                  committedChanged: true,
                },
                () => {
                  this.trackChanges();
                }
              );
            } else {
              this.setState(
                {
                  committedChanged: false,
                },
                () => {
                  this.trackChanges();
                }
              );
            }
          }
        );
      }
    }
  };

  trackErrors = () => {
    if (this.state.emailError) {
      this.setState({
        formError: true,
      });
    } else {
      this.setState({
        formError: false,
      });
    }
  };

  trackChanges = () => {
    if (
      this.state.firstNameChanged ||
      this.state.lastNameChanged ||
      this.state.classChanged ||
      this.state.sportChanged ||
      this.state.positionChanged ||
      this.state.emailChanged ||
      this.state.advocateChanged ||
      this.state.teamNameChanged ||
      this.state.committedChanged ||
      this.state.imageCropped ||
      this.state.schoolNameChanged ||
      this.state.editImageCropped ||
      this.state.editSchoolNameChanged
    ) {
      this.setState({
        changesMade: true,
      });
    } else {
      this.setState({
        changesMade: false,
      });
    }
  };

  checkErrors = (e) => {
    e.preventDefault();

    this.setState(
      {
        athleteTriedToUpdate: true,
        isLoading: true,
      },
      () => {
        this.handleSubmit(e);
      }
    );
  };

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.addAthlete(this.state);
  };

  handleExit = () => {
    this.setState(initialState, () => {
      this.props.resetAthlete();
    });
  };

  checkSchoolErrors = (e) => {
    e.preventDefault();

    this.setState(
      {
        athleteTriedToUpdate: true,
        isLoading: true,
      },
      () => {
        this.handleSchoolSubmit(e);
      }
    );
  };
  handleShowNewSportFieldOpen = () => {
    this.setState({
      showNewSportField: !this.state.showNewSportField,
    });
  };
  handleShowNewPositionFieldOpen = () => {
    this.setState({
      showNewPositionField: !this.state.showNewPositionField,
    });
  };
  checkEditSchoolErrors = (e) => {
    e.preventDefault();

    this.setState(
      {
        athleteTriedToUpdate: true,
        isLoading: true,
      },
      () => {
        this.handleEditSchoolSubmit(e);
      }
    );
  };

  handleSchoolSubmit = (e) => {
    e.preventDefault();
    this.props.addSchool(this.state);
  };

  handleEditSchoolSubmit = (e) => {
    e.preventDefault();
    this.props.editSchool(this.state);
  };

  fileSelectedHandler = (event) => {
    this.setState({
      newThumbnailImage: event.target.files[0],
      newThumbnailImageUrl: URL.createObjectURL(event.target.files[0]),
      cropImageOpen: true,
    });
  };

  editFileSelectedHandler = (event) => {
    this.setState({
      newEditThumbnailImage: event.target.files[0],
      newEditThumbnailImageUrl: URL.createObjectURL(event.target.files[0]),
      editCropImageOpen: true,
    });
  };

  handleEditImageClose = () => {
    if (this.state.cropImageOpen) {
      return;
    } else {
      if (this.state.imageCropped) {
        this.setState({
          thumbnail: this.state.croppedImageBlob,
          thumbnailChanged: true,
          cropImageOpen: false,
        });
      } else {
        this.setState({
          imageCropped: false,
          cropImageOpen: false,
        });
      }
    }
  };

  handleEditSchoolImageClose = () => {
    if (this.state.editCropImageOpen) {
      return;
    } else {
      if (this.state.editImageCropped) {
        this.setState({
          editSchoolLogo: this.state.editCroppedImageBlob,
          editSchoolLogoChanged: true,
          editCropImageOpen: false,
        });
      } else {
        this.setState({
          editImageCropped: false,
          editCropImageOpen: false,
        });
      }
    }
  };

  upload = () => {
    document.getElementById("thumbnail").click();
  };

  uploadEdit = () => {
    document.getElementById("thumbnailEdit").click();
  };

  handleImageEvent = (type) => {
    if (type === "close" || type === "loadabort") {
      this.setState(
        {
          cropImageOpen: false,
        },
        () => {
          this.handleEditImageClose();
        }
      );
    }
  };

  handleEditImageEvent = (type) => {
    if (type === "close" || type === "loadabort") {
      this.setState(
        {
          editCropImageOpen: false,
        },
        () => {
          this.handleEditSchoolImageClose();
        }
      );
    }
  };

  processImage = (dest) => {
    this.setState(
      {
        croppedImageBlob: dest,
        croppedImageBlobUrl: URL.createObjectURL(dest),
      },
      () => {
        this.handleImageApplyCrop();
      }
    );
  };

  processEditImage = (dest) => {
    this.setState(
      {
        editCroppedImageBlob: dest,
        editCroppedImageBlobUrl: URL.createObjectURL(dest),
      },
      () => {
        this.handleEditImageApplyCrop();
      }
    );
  };

  handleImageApplyCrop = () => {
    this.setState(
      {
        imageCropped: true,
        cropImageOpen: false,
      },
      () => {
        this.trackChanges();
      }
    );
  };

  handleEditImageApplyCrop = () => {
    this.setState(
      {
        editImageCropped: true,
        editCropImageOpen: false,
      },
      () => {
        this.trackChanges();
      }
    );
  };

  render() {
    // if NOT logged in AND NOT superAdmin then redirect
    const { auth, superAdmin } = this.props;

    if (!auth.uid && !superAdmin) {
      return <Redirect to="/login" />;
    } else {
      if (this.state.searchEnabled) {
        searchBar = (
          <Input
            key={this.state.key}
            icon={searchIcon}
            placeholder="Search Athletes..."
            name="filteredSearch"
            onChange={this.handleOnChange}
          />
        );
      } else {
        searchIcon = "search";
        searchBar = (
          <Input
            key={this.state.key}
            icon={searchIcon}
            placeholder="Search Athletes..."
            name="filteredSearch"
            onChange={this.handleOnChange}
          />
        );
      }

      var addAthleteDetails = null;
      var athleteProfileUpdated = null;
      var formFirstName = null;
      var formLastName = null;
      var formEmail = null;
      var formAdvocate = null;
      var formClass = null;
      var formCommitted = null;
      var formSchoolName = null;
      var formEditSchoolName = null;
      var committedDetails = null;
      var formSport = null;
      var formPosition = null;
      var formTeamName = null;
      var formClubTeamName = null;
      var saveButton = null;

      var addSchoolButton = null;
      var schoolSaveButton = null;
      var schoolEditButton = null;

      var formThumbnail = null;
      var editFormThumbnail = null;

      var newSchoolDetails = null;
      var newEditSchoolDetails = null;

      var schoolUpdated = null;
      var schoolInfoEdited = null;

      const animation = "scale";
      const duration = 200;

      formFirstName = (
        <input
          placeholder="None"
          id="firstName"
          value={this.state.firstName}
          onChange={this.handleChange}
        />
      );
      formLastName = (
        <input
          placeholder="None"
          id="lastName"
          value={this.state.lastName}
          onChange={this.handleChange}
        />
      );

      if (this.state.emailError) {
        formEmail = (
          <Form.Input
            placeholder="None"
            id="email"
            value={this.state.email}
            onChange={this.handleChange}
            error={{ content: "Please check email address", pointing: "below" }}
          />
        );
      } else {
        formEmail = (
          <input
            placeholder="None"
            id="email"
            value={this.state.email}
            onChange={this.handleChange}
          />
        );
      }

      formAdvocate = (
        <Dropdown
          search
          loading={!this.props.advocates && this.props.advocates.length < 1}
          disabled={!this.props.advocates && this.props.advocates.length < 1}
          options={this.props.advocates}
          selection
          fluid
          placeholder="None"
          value={this.state.advocate}
          name="advocateDropdown"
          onChange={this.handleDropdownChange}
        />
      );
      formClass = (
        <Dropdown
          options={classOptions}
          selection
          fluid
          placeholder="None"
          value={this.state.class}
          name="classDropdown"
          onChange={this.handleDropdownChange}
        />
      );

      formCommitted = (
        <Dropdown
          options={committedOptions}
          selection
          fluid
          placeholder="Uncommitted"
          value={this.state.committedValue}
          name="committedDropdown"
          onChange={this.handleDropdownChange}
        />
      );
      formSport = (
        <SportList
          value={this.state.sport}
          onChange={this.handleDropdownChange}
          name="sportDropdown"
        />
      );
      formPosition = (
        <PositionList
          value={this.state.position}
          onChange={this.handleDropdownChange}
          name="positionDropdown"
          sport={this.state.sport}
          disabled={!this.state.sport}
        />
      );
      formTeamName = (
        <input
          placeholder="None"
          id="teamName"
          value={this.state.teamName}
          onChange={this.handleChange}
        />
      );

      if (this.state.sport === "football") {
        formClubTeamName = null;
      } else {
        formClubTeamName = (
          <Form.Field>
            <label>Club Team Name</label>
            {formTeamName}
          </Form.Field>
        );
      }

      editFormThumbnail = (
        <img src={this.state.editSchoolLogo} alt="University Logo" />
      );
      formThumbnail = (
        <img
          src={require("../../images/universityIcon.svg").default}
          alt="University Building"
        />
      );

      formSchoolName = (
        <input
          placeholder="None"
          id="schoolName"
          required="true"
          value={this.state.schoolName}
          onChange={this.handleChange}
        />
      );
      formEditSchoolName = (
        <input
          placeholder="None"
          id="editSchoolName"
          required="true"
          value={this.state.editSchoolName}
          onChange={this.handleChange}
        />
      );

      if (
        this.state.changesMade &&
        !this.state.formError &&
        !this.state.athleteTriedToUpdate &&
        this.state.firstNameChanged &&
        this.state.lastNameChanged &&
        this.state.emailChanged &&
        this.state.advocateChanged &&
        this.state.classChanged &&
        this.state.positionChanged &&
        this.state.sportChanged
      ) {
        saveButton = (
          <Button
            floated="right"
            positive
            name="saveButton"
            content="Save"
            labelPosition="right"
            icon="checkmark"
            onClick={this.checkErrors}
          />
        );
      } else {
        if (this.state.formError) {
          saveButton = (
            <Button
              disabled
              floated="right"
              color="red"
              name="saveButton"
              content="Please Check Error(s)"
              labelPosition="right"
              icon="exclamation"
              onClick={this.checkErrors}
            />
          );
        } else {
          if (this.state.athleteTriedToUpdate) {
            saveButton = (
              <Button
                disabled
                loading
                floated="right"
                positive
                name="saveButton"
                content="Save"
                labelPosition="right"
                icon="checkmark"
                onClick={this.checkErrors}
              />
            );
          } else {
            saveButton = (
              <Button
                disabled
                floated="right"
                positive
                name="saveButton"
                content="Save"
                labelPosition="right"
                icon="checkmark"
                onClick={this.checkErrors}
              />
            );
          }
        }
      }

      addSchoolButton = (
        <Button
          floated="right"
          positive
          name="addSchoolButton"
          content="Add School"
          labelPosition="right"
          icon="add"
          onClick={() =>
            this.setState({
              addNewSchoolOpen: true,
            })
          }
        />
      );

      if (this.state.imageCropped && this.state.schoolNameChanged) {
        if (this.state.athleteTriedToUpdate) {
          schoolSaveButton = (
            <Button
              disabled
              loading
              floated="right"
              positive
              name="saveButton"
              content="Save"
              labelPosition="right"
              icon="checkmark"
              onClick={this.checkSchoolErrors}
            />
          );
        } else {
          schoolSaveButton = (
            <Button
              floated="right"
              positive
              name="saveButton"
              content="Save"
              labelPosition="right"
              icon="checkmark"
              onClick={this.checkSchoolErrors}
            />
          );
        }
      } else {
        schoolSaveButton = (
          <Button
            disabled
            floated="right"
            positive
            name="saveButton"
            content="Save"
            labelPosition="right"
            icon="checkmark"
            onClick={this.checkSchoolErrors}
          />
        );
      }

      if (this.state.editImageCropped || this.state.editSchoolNameChanged) {
        if (this.state.athleteTriedToUpdate) {
          schoolEditButton = (
            <Button
              disabled
              loading
              floated="right"
              positive
              name="saveButton"
              content="Save"
              labelPosition="right"
              icon="checkmark"
              onClick={this.checkEditSchoolErrors}
            />
          );
        } else {
          schoolEditButton = (
            <Button
              floated="right"
              positive
              name="saveButton"
              content="Save"
              labelPosition="right"
              icon="checkmark"
              onClick={this.checkEditSchoolErrors}
            />
          );
        }
      } else {
        schoolEditButton = (
          <Button
            disabled
            floated="right"
            positive
            name="saveButton"
            content="Save"
            labelPosition="right"
            icon="checkmark"
            onClick={this.checkEditSchoolErrors}
          />
        );
      }

      const { addAthleteError, athleteAdded } = this.props;

      if (this.state.athleteTriedToUpdate && athleteAdded) {
        athleteProfileUpdated = (
          <TransitionablePortal
            transition={{ animation, duration }}
            open={athleteAdded}
            onClose={this.handleExit}
          >
            <Modal onClose={this.handleExit} open={true}>
              <Modal.Content>
                <div className="AdminProfileUpdatedContainer">
                  <h3>Athlete Added!</h3>
                  <Button
                    positive
                    name="okButton"
                    content="OK"
                    onClick={this.handleExit}
                  />
                </div>
              </Modal.Content>
            </Modal>
          </TransitionablePortal>
        );
      }

      if (this.state.athleteTriedToUpdate && addAthleteError) {
        athleteProfileUpdated = (
          <TransitionablePortal
            transition={{ animation, duration }}
            open={addAthleteError}
            onClose={this.handleExit}
          >
            <Modal onClose={this.handleExit} open={true}>
              <Modal.Content>
                <div className="AdminProfileUpdatedContainer">
                  <h3>
                    There was an error adding the athlete. Please try a
                    different email address or contact support.
                  </h3>
                  <Button
                    color="blue"
                    name="okButton"
                    content="OK"
                    onClick={this.handleExit}
                  />
                </div>
              </Modal.Content>
            </Modal>
          </TransitionablePortal>
        );
      }

      const { addSchoolError, schoolAdded, editSchoolError, schoolEdited } =
        this.props;

      if (this.state.athleteTriedToUpdate && schoolAdded) {
        schoolUpdated = (
          <TransitionablePortal
            transition={{ animation, duration }}
            open={schoolAdded}
            onClose={this.handleExit}
          >
            <Modal onClose={this.handleExit} open={true}>
              <Modal.Content>
                <div className="AdminProfileUpdatedContainer">
                  <h3>School Added!</h3>
                  <Button
                    positive
                    name="okButton"
                    content="OK"
                    onClick={this.handleExit}
                  />
                </div>
              </Modal.Content>
            </Modal>
          </TransitionablePortal>
        );
      }

      if (this.state.athleteTriedToUpdate && addSchoolError) {
        schoolUpdated = (
          <TransitionablePortal
            transition={{ animation, duration }}
            open={addSchoolError}
            onClose={this.handleExit}
          >
            <Modal onClose={this.handleExit} open={true}>
              <Modal.Content>
                <div className="AdminProfileUpdatedContainer">
                  <h3>
                    There was an error adding the school. Please try again or
                    contact support.
                  </h3>
                  <Button
                    color="blue"
                    name="okButton"
                    content="OK"
                    onClick={this.handleExit}
                  />
                </div>
              </Modal.Content>
            </Modal>
          </TransitionablePortal>
        );
      }
      if (this.state.athleteTriedToUpdate && schoolEdited) {
        schoolInfoEdited = (
          <TransitionablePortal
            transition={{ animation, duration }}
            open={schoolEdited}
            onClose={this.handleExit}
          >
            <Modal onClose={this.handleExit} open={true}>
              <Modal.Content>
                <div className="AdminProfileUpdatedContainer">
                  <h3>School Updated!</h3>
                  <Button
                    positive
                    name="okButton"
                    content="OK"
                    onClick={this.handleExit}
                  />
                </div>
              </Modal.Content>
            </Modal>
          </TransitionablePortal>
        );
      }

      if (this.state.athleteTriedToUpdate && editSchoolError) {
        schoolInfoEdited = (
          <TransitionablePortal
            transition={{ animation, duration }}
            open={editSchoolError}
            onClose={this.handleExit}
          >
            <Modal onClose={this.handleExit} open={true}>
              <Modal.Content>
                <div className="AdminProfileUpdatedContainer">
                  <h3>
                    There was an error updating the school. Please try again or
                    contact support.
                  </h3>
                  <Button
                    color="blue"
                    name="okButton"
                    content="OK"
                    onClick={this.handleExit}
                  />
                </div>
              </Modal.Content>
            </Modal>
          </TransitionablePortal>
        );
      }

      if (this.state.addAthleteOpen) {
        addAthleteDetails = (
          <div className="AdminFormContainer">
            <Form>
              <div className="AdminFormPersonalInfoContainer">
                <h3>Add Athlete</h3>
                <p>*All fields are required</p>
                <Form.Field>
                  <label>First Name</label>
                  {formFirstName}
                </Form.Field>
                <Form.Field>
                  <label>Last Name</label>
                  {formLastName}
                </Form.Field>
                <Form.Field>
                  <label>Email</label>
                  {formEmail}
                </Form.Field>
                <Form.Field>
                  <label>Advocate</label>
                  {formAdvocate}
                </Form.Field>
                <Form.Field>
                  <label>Grad Year</label>
                  {formClass}
                </Form.Field>
                <Form.Field>
                  <label>Status</label>
                  {formCommitted}
                </Form.Field>
                <Form.Field>
                  <label>
                    Sport{" "}
                    <AddNewSportIcon
                      onClick={this.handleShowNewSportFieldOpen}
                    />
                  </label>
                  {this.state.showNewSportField && (
                    <AddNewSport onClose={this.handleShowNewSportFieldOpen} />
                  )}
                  {formSport}
                </Form.Field>
                <Form.Field>
                  <label>
                    Position{" "}
                    <AddNewPositionIcon
                      onClick={this.handleShowNewPositionFieldOpen}
                    />
                  </label>
                  {this.state.showNewPositionField && (
                    <AddNewPosition
                      onClose={this.handleShowNewPositionFieldOpen}
                    />
                  )}
                  {formPosition}
                </Form.Field>
                {formClubTeamName}
              </div>
              {athleteProfileUpdated}
            </Form>
          </div>
        );
      } else {
        addAthleteDetails = null;
      }

      if (this.state.committedOpen) {
        committedDetails = (
          <div className="AdminFormContainer">
            <SchoolList selectSchool={this.onSelectSchool} />
          </div>
        );
      } else {
        committedDetails = null;
      }

      if (this.state.addNewSchoolOpen) {
        newSchoolDetails = (
          <div className="NewSchoolDetailsContainer">
            <Form>
              <div className="NewSchoolInfoContainer">
                <Form.Field required>
                  <label>School Name</label>
                  {formSchoolName}
                </Form.Field>
              </div>
              {schoolUpdated}
            </Form>
          </div>
        );
      } else {
        newSchoolDetails = null;
      }

      if (this.state.editSchoolOpen) {
        newEditSchoolDetails = (
          <div className="NewSchoolDetailsContainer">
            <Form>
              <div className="NewSchoolInfoContainer">
                <Form.Field required>
                  <label>School Name</label>
                  {formEditSchoolName}
                </Form.Field>
              </div>
              {schoolInfoEdited}
            </Form>
          </div>
        );
      } else {
        newEditSchoolDetails = null;
      }

      if (this.state.imageCropped) {
        if (this.state.croppedImageBlobUrl) {
          formThumbnail = (
            <img
              alt="Crop"
              style={{ maxWidth: "100%" }}
              src={this.state.croppedImageBlobUrl}
            />
          );
        }
      }

      if (this.state.editImageCropped) {
        if (this.state.editCroppedImageBlobUrl) {
          editFormThumbnail = (
            <img
              alt="Crop"
              style={{ maxWidth: "100%" }}
              src={this.state.editCroppedImageBlobUrl}
            />
          );
        }
      }

      return (
        <div className="AthleteSearchContainer">
          <div className="AthleteSearchBannerBar"></div>
          <div className="AthleteSearchBanner">
            <h1>Athletes</h1>
            <div className="AthleteSearchFilterContainer">
              <Input
                key={this.state.key}
                icon={searchIcon}
                placeholder="Search Athletes..."
                name="filteredSearch"
                onChange={this.handleOnChange}
                value={this.state.search}
              />
              <div className="AthleteSearchFilter">
                <SportList
                  placeholder="Sport"
                  name="filteredSport"
                  onChange={this.handleOnChange}
                  clearable
                />
                <ClassYearDropDown
                  clearable
                  selection
                  fluid
                  placeholder="Class"
                  name="filteredClass"
                  onChange={this.handleOnChange}
                  admin={true}
                  commit={false}
                />
                <PositionList
                  placeholder="Position"
                  name="filteredPosition"
                  onChange={this.handleOnChange}
                  sport={this.state.filteredSport}
                  disabled={!this.state.filteredSport}
                  value={this.state.filteredPosition}
                />
                <Dropdown
                  clearable
                  options={filteredAcademicsOptions}
                  selection
                  fluid
                  placeholder="Academics"
                  name="filteredAcademics"
                  onChange={this.handleOnChange}
                />
              </div>
            </div>
          </div>
          <div className="AddAthleteButtonContainer">
            <Link to={"/super-admin/testimonials"}>
              <Button
                icon="quote left"
                content="Testimonials"
                labelPosition="left"
                color="twitter"
                name="editedButton"
              />
            </Link>
            {/* <Link to={"/updatehistory"}>
              <Button
                icon="level up alternate"
                content="Update History"
                labelPosition="left"
                color="black"
                name="editedButton"
              />
            </Link> */}
            <Link to={"/super-admin/events"}>
              <Button
                icon="calendar alternate"
                labelPosition="left"
                color="vk"
                name="editedButton"
                content="Events"
              />
            </Link>
            <Link to={"/super-admin/commitmentvideos"}>
              <Button
                icon="university"
                labelPosition="left"
                color="google plus"
                name="editedButton"
                content="Commitment Videos"
              />
            </Link>
            <Link to={"/super-admin/media"}>
              <Button
                icon="newspaper"
                labelPosition="left"
                color="facebook"
                name="editedButton"
                content="Media"
              />
            </Link>
            <Link to={"/super-admin/newrequests"}>
              <Button
                icon
                labelPosition="left"
                color="violet"
                name="ApprovalsButton"
              >
                <Icon name="check circle outline" />
                Approvals
              </Button>
            </Link>
            <Link to={"/super-admin/wiki"}>
              <Button
                icon="wikipedia w"
                labelPosition="left"
                color="grey"
                name="editedButton"
                content="Wiki"
              />
            </Link>
            <Button
              icon="basketball ball"
              labelPosition="left"
              color="pink"
              name="editedButton"
              onClick={this.handleEditSportsClick}
              content="Sports & Position"
            />
            <Button
              icon="youtube"
              labelPosition="left"
              color="purple"
              name="PlayerButton"
              onClick={this.handlePlayersClick}
              content="Players To Watch"
            />
            <Link to={"/super-admin/skillslist"}>
              <Button
                icon="video"
                labelPosition="left"
                color="teal"
                name="SkillsButton"
                content="Skills"
              />
            </Link>
            <Link to={"/super-admin/partners"}>
              <Button
                icon="users"
                labelPosition="left"
                color="instagram"
                name="PartnersButton"
                content="Partners"
              />
            </Link>
            <Link to={"/super-admin/advocatelist"}>
              <Button
                icon
                labelPosition="left"
                color="brown"
                name="advocatesButton"
              >
                <i aria-hidden="true" className="icon svgs">
                  <TbLetterA />
                </i>
                About
              </Button>
            </Link>
            <Link to={"/super-admin/reminders"}>
              <Button
                icon="bell"
                labelPosition="left"
                color="black"
                name="advocatesButton"
                content="Reminders"
              />
            </Link>
            <Button
              icon="graduation"
              labelPosition="left"
              color="blue"
              name="committedButton"
              onClick={this.handleCommittedClick}
              content="View Schools"
            />
            <Button
              icon="add user"
              labelPosition="left"
              color="green"
              name="addAthleteButton"
              onClick={this.handleAddAthleteClick}
              content="Add Athlete"
            />
          </div>
          {/* edit sports */}
          <Modal
            onClose={() => this.handlespClose()}
            open={this.state.editSportOpen}
          >
            <Modal.Content
              scrolling
              className={
                this.state.showNewSportField || this.state.showNewPositionField
                  ? "active"
                  : ""
              }
            >
              {this.state.showNewSportField && (
                <AddNewSport onClose={this.handleShowNewSportFieldOpen} />
              )}
              {this.state.showNewPositionField && (
                <AddNewPosition onClose={this.handleShowNewPositionFieldOpen} />
              )}
              <div className="AdminTopButtonsProgressContainer">
                <div className="AdminTopButtonsContainer button-mb">
                  <Button
                    floated="left"
                    circular
                    icon="close"
                    onClick={() => this.handlespClose()}
                  />
                  <Button
                    size="small"
                    floated="right"
                    positive
                    name="saveButton"
                    content="Add position"
                    labelPosition="right"
                    icon="plus"
                    onClick={this.handleShowNewPositionFieldOpen}
                  />
                  <Button
                    size="small"
                    floated="right"
                    positive
                    name="saveButton"
                    content="Add sport"
                    labelPosition="right"
                    icon="plus"
                    onClick={this.handleShowNewSportFieldOpen}
                  />
                </div>
              </div>
              <SportDetails close={this.handlespClose} />
              <Modal onClose={() => this.handlePostionClose()} open={true}>
                <Modal.Content>
                  <div className="AdminTopButtonsProgressContainer">
                    <div className="AdminTopButtonsContainer button-mb">
                      <Button
                        floated="left"
                        circular
                        icon="close"
                        onClick={() => this.handlePostionClose()}
                      />
                      <Button
                        floated="right"
                        positive
                        name="saveButton"
                        content="Save"
                        labelPosition="right"
                        icon="check"
                      />
                    </div>
                  </div>
                </Modal.Content>
              </Modal>
            </Modal.Content>
          </Modal>

          <TransitionablePortal
            transition={{ animation, duration }}
            open={this.state.addAthleteOpen}
            onClose={() => this.handleClose()}
          >
            <Modal onClose={() => this.handleClose()} open={true}>
              <Modal.Content
                scrolling
                className={
                  this.state.showNewSportField ||
                  this.state.showNewPositionField
                    ? "active"
                    : ""
                }
              >
                <div className="AdminTopButtonsProgressContainer">
                  <div className="AdminTopButtonsContainer">
                    <Button
                      floated="left"
                      circular
                      icon="close"
                      onClick={() => this.handleClose()}
                    />
                    {saveButton}
                  </div>
                </div>
                {addAthleteDetails}
                <Confirm
                  open={this.state.confirmOpen}
                  content="You have unsaved changes.  Are you sure you want to exit?"
                  onCancel={this.confirmCloseCancel}
                  onConfirm={this.confirmClose}
                />
              </Modal.Content>
            </Modal>
          </TransitionablePortal>
          <TransitionablePortal
            transition={{ animation, duration }}
            open={this.state.committedOpen}
            onClose={() => this.handleCommittedClose()}
          >
            <Modal onClose={() => this.handleCommittedClose()} open={true}>
              <Modal.Content scrolling>
                <div className="AdminTopButtonsProgressContainer">
                  <div className="AdminTopButtonsContainer">
                    <Button
                      floated="left"
                      circular
                      icon="close"
                      onClick={() => this.handleCommittedClose()}
                    />
                    {addSchoolButton}
                  </div>
                </div>
                <TransitionablePortal
                  transition={{ animation, duration }}
                  open={this.state.addNewSchoolOpen}
                  onClose={() => this.handleNewSchoolClose()}
                >
                  <Modal
                    onClose={() => this.handleNewSchoolClose()}
                    open={true}
                  >
                    <Modal.Content>
                      <div className="NewSchoolFormContainer">
                        <div className="AdminTopButtonsDropzoneContainer">
                          <div className="AdminTopButtonsContainer">
                            <Button
                              floated="left"
                              circular
                              icon="close"
                              onClick={() => this.handleNewSchoolClose()}
                            />
                            {schoolSaveButton}
                          </div>
                        </div>

                        <div className="NewSchoolThumbnailContainer">
                          <input
                            value={""}
                            style={{ display: "none" }}
                            id={"thumbnail"}
                            type="file"
                            onChange={this.fileSelectedHandler}
                          />
                          <Button
                            floated="right"
                            name="editThumbnailButton"
                            icon="pencil"
                            onClick={() => this.upload()}
                          />
                          <TransitionablePortal
                            transition={{ animation, duration }}
                            open={this.state.cropImageOpen}
                            onClose={() => this.handleEditImageClose()}
                          >
                            <Modal
                              onClose={() => this.handleEditImageClose()}
                              open={true}
                            >
                              <div className="AdminEditImageContainer">
                                <Modal.Content>
                                  {this.state.newThumbnailImage && (
                                    <div className="AdminImageEditorContainer">
                                      <DokaImageEditor
                                        {...editorConfig}
                                        src={this.state.newThumbnailImageUrl}
                                        enableButtonClose={true}
                                        handleEvent={(type) =>
                                          this.handleImageEvent(type)
                                        }
                                        onLoad={(res) => {}}
                                        imageCropAspectRatio={1}
                                        onProcess={({ dest }) =>
                                          this.processImage(dest)
                                        }
                                      />
                                    </div>
                                  )}
                                </Modal.Content>
                              </div>
                            </Modal>
                          </TransitionablePortal>
                          {formThumbnail}
                        </div>
                        {newSchoolDetails}
                      </div>
                    </Modal.Content>
                  </Modal>
                </TransitionablePortal>
                <TransitionablePortal
                  transition={{ animation, duration }}
                  open={this.state.editSchoolOpen}
                  onClose={() => this.handleEditSchoolClose()}
                >
                  <Modal
                    onClose={() => this.handleEditSchoolClose()}
                    open={true}
                  >
                    <Modal.Content>
                      <div className="NewSchoolFormContainer">
                        <div className="AdminTopButtonsDropzoneContainer">
                          <div className="AdminTopButtonsContainer">
                            <Button
                              floated="left"
                              circular
                              icon="close"
                              onClick={() => this.handleEditSchoolClose()}
                            />
                            {schoolEditButton}
                          </div>
                        </div>

                        <div className="NewSchoolThumbnailContainer">
                          <input
                            value={""}
                            style={{ display: "none" }}
                            id={"thumbnailEdit"}
                            type="file"
                            onChange={this.editFileSelectedHandler}
                          />
                          <Button
                            floated="right"
                            name="editThumbnailButton"
                            icon="pencil"
                            onClick={() => this.uploadEdit()}
                          />
                          <TransitionablePortal
                            transition={{ animation, duration }}
                            open={this.state.editCropImageOpen}
                            onClose={() => this.handleEditSchoolImageClose()}
                          >
                            <Modal
                              onClose={() => this.handleEditSchoolImageClose()}
                              open={true}
                            >
                              <div className="AdminEditImageContainer">
                                <Modal.Content>
                                  {this.state.newEditThumbnailImage && (
                                    <div className="AdminImageEditorContainer">
                                      <DokaImageEditor
                                        {...editorConfig}
                                        src={
                                          this.state.newEditThumbnailImageUrl
                                        }
                                        enableButtonClose={true}
                                        handleEvent={(type) =>
                                          this.handleEditImageEvent(type)
                                        }
                                        onLoad={(res) => {}}
                                        imageCropAspectRatio={1}
                                        onProcess={({ dest }) =>
                                          this.processEditImage(dest)
                                        }
                                      />
                                    </div>
                                  )}
                                </Modal.Content>
                              </div>
                            </Modal>
                          </TransitionablePortal>
                          {editFormThumbnail}
                        </div>
                        {newEditSchoolDetails}
                      </div>
                    </Modal.Content>
                  </Modal>
                </TransitionablePortal>
                {committedDetails}
                <Confirm
                  open={this.state.confirmOpen}
                  content="You have unsaved changes.  Are you sure you want to exit?"
                  onCancel={this.confirmCloseCancel}
                  onConfirm={this.confirmClose}
                />
              </Modal.Content>
            </Modal>
          </TransitionablePortal>

          {/* players to watch */}

          <Modal
            onClose={() => this.handlePlayertoWatchClose()}
            open={this.state.playersOpen}
          >
            <Modal.Content scrolling>
              {this.state.playersOpen && (
                <NewPlayersToWatch
                  onClose={() => this.handlePlayertoWatchClose()}
                />
              )}
            </Modal.Content>
          </Modal>

          {/* AddSkills */}

          <Modal
            onClose={() => this.handleManagePlaylistsClose()}
            open={this.state.managePlaylists}
          >
            <Modal.Content scrolling>
              {this.state.managePlaylists && (
                <SkillsList onClose={() => this.handleManagePlaylistsClose()} />
              )}
            </Modal.Content>
          </Modal>

          <div className="AthleteSearchDetail">
            <AthleteAdminList
              filteredSearch={this.state.debounceSearch}
              filteredSport={this.state.filteredSport}
              filteredGradClass={this.state.filteredGradClass}
              filteredPosition={this.state.filteredPosition}
              filteredAcademics={this.state.filteredAcademics}
            />
          </div>
        </div>
      );
    }
  }
}

const mapStateToProps = (state) => {
  let advocateOptions = [];
  const advocates = state.firestore.ordered.advocates;
  if (advocates && advocates.length > 0) {
    advocateOptions = advocates.map((advocate, index) => {
      return { key: index, text: advocate.name, value: advocate.name };
    });
    advocateOptions = advocateOptions.sort((a, b) =>
      a.text.localeCompare(b.text)
    );
  }
  return {
    advocates: advocateOptions,
    sportsArray: state.firestore.ordered.sports,
    auth: state.firebase.auth,
    superAdmin: state.auth.superAdmin,
    addAthleteError: state.athlete.addAthleteError,
    athleteAdded: state.athlete.athleteAdded,
    addSchoolError: state.athlete.addSchoolError,
    schoolAdded: state.athlete.schoolAdded,
    editSchoolError: state.athlete.editSchoolError,
    schoolEdited: state.athlete.schoolEdited,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    addAthlete: (athleteInfo) => dispatch(addAthlete(athleteInfo)),
    resetAthlete: () => dispatch(resetAthlete()),
    addSchool: (schoolInfo) => dispatch(addSchool(schoolInfo)),
    editSchool: (schoolInfo) => dispatch(editSchool(schoolInfo)),
  };
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  firestoreConnect(() => [
    {
      collection: "sports",
    },
    {
      collection: "advocates",
    },
  ])
)(AthleteAdminSearch);
